{
  "sign_in": "Logga in",
  "password": "Lösenord",
  "username_email": "Användarnamn eller e-post",
  "username": "Användarnamn",
  "email": "E-post",
  "reset_password": "Återställ lösenord",
  "forgot_password": "Glömt ditt lösenord",
  "enter_password": "Skriv in ditt lösenord",
  "enter_username_email": "Skriv in ditt användarnamn eller din e-post",
  "enter_email": "Skriv in din e-post",
  "enter_username": "Skriv in ditt användarnamn",
  "home": "Hem",
  "system_settings": "Configuration",
  "app_settings": "App Settings",
  "reservation_modes": "Bokningslägen",
  "reservation_templates": "Bokningsmallar",
  "types": "Typer",
  "fields": "Fält",
  "member_types": "Medlemstyper",
  "relation_types": "Relationstyper",
  "availability_types": "Tillgänglighetstyper",
  "field_relations": "Fältrelationer",
  "periods": "Perioder",
  "holiday_reservations": "Semesterbokningar",
  "system_preferences": "Systempreferenser",
  "maintenance": "Underhåll",
  "organizations_users": "User Management",
  "api_services": "API och tjänster",
  "object_settings": "Objektinställningar",
  "organizations": "Organisationer",
  "roles_permissions": "Roles och behörigheter",
  "user_manager": "Användare",
  "auth_configs": "Autentiseringskonfigurationer",
  "services": "Tjänster",
  "auto_engine_tokens": "Auto-tokens",
  "object_manager": "Objekthanterare",
  "system": "System",
  "reservation_mode": "Bokningsläge",
  "reservation_template": "Bokningsmall",
  "type": "Typ",
  "field": "Fält",
  "member_relation_type": "Medlemsrelationstyp",
  "relation_type": "Relationstyp",
  "field_relation": "Fältrelation",
  "availability_type": "Tillgänglighetsrelation",
  "time_rule": "Tidsregel",
  "period": "Period",
  "object": "Objekt",
  "save_changes": "Spara ändringar",
  "discard_changes": "Kassera ändringar",
  "batch_operations": "Batchoperationer",
  "import_objects": "Importera objekt",
  "documentation": "Dokumentation",
  "general_settings": "Allmänna inställningar",
  "language_preferences": "Språkpreferenser",
  "connections": "Kopplingar",
  "move_reservations": "Flytta bokningar",
  "properties_subtypes": "Egenskaper och undertyper",
  "organizations_templates": "Organisationer och mallar",
  "preferences": "Inställningar",
  "references": "Referenser",
  "configuration": "Inställningar",
  "details": "Detaljer",
  "templates": "Mallar",
  "intervals_and_related_periods": "Intervaller och relaterade perioder",
  "name": "Namn",
  "description": "Beskrivning",
  "language": "Språk",
  "alt_name": "Alt. namn",
  "alt_description": "Alt. beskrivning",
  "show_in_client": "Visa i klienten",
  "show_in_culling": "Visa i gallring",
  "list_by_name": "Lista efter namn",
  "list_by_extid": "Lista efter ext.id",
  "member_relation_types": "Medlemsrelationstyper",
  "availability_relation_types": "Tillgänglighetsrelationstyper",
  "availability_relation_type": "Tillgänglighetsrelationstyp",
  "id": "Id",
  "ext_id": "Ext.id",
  "private_role": "Privat roll",
  "standard_organization": "Standardorganisation",
  "default_status": "Standardstatus",
  "active": "Aktiv",
  "auth_config_active": "Aktiv autentieringskonfiguration",
  "affect_orders": "Påverkar ordrar",
  "delete_reservation_when_culling": "Ta bort bokning vid gallring",
  "properties": "Egenskaper",
  "occurrence": "Förekomst",
  "members": "Medlemmar",
  "availability": "Tillgänglighet",
  "special": "Special",
  "text": "Text",
  "result": "Resultat",
  "move_to": "Flytta till",
  "count": "Räkna",
  "from_date": "Från datum",
  "choose_type": "Välj typ",
  "combinations": "Kombinationer",
  "sort": "Sortera",
  "action": "Handling",
  "yes": "Ja",
  "no": "Nej",
  "sure_to_delete": "Är du säker på att du vill radera den här typen",
  "min_max": "Min/max",
  "reservation_kind": "Bokningstyp",
  "ma_com_opt": "Obl. / Komb. / Friv.",
  "obj_virt_inco": "Obj. / Virt. / Ofullst.",
  "member_type": "Medlemstyp",
  "request_type": "Typ av begäran",
  "canc_per": "Avbryt beh.",
  "opt_rel": "Fri.rel",
  "auto_o": "Auto.o",
  "res_text": "Res.text",
  "obst_text": "Hind.text",
  "add_type": "Lägg till typ",
  "personal_data": "Personlig information",
  "warning_not_delete_type_in_use": "VARNING! Du kan INTE ta bort en typ som används!",
  "allow_standard_objects": "Tillåt standardobjekt",
  "allow_abstract_objects": "Tillåt abstrakta objekt",
  "allow_virtual_objects": "Tillåt virtuella objekt",
  "person_type": "Persontyp",
  "location_type": "Platstyp",
  "alias_type": "Aliastyp",
  "external_ownership": "Externt ägande",
  "subtypes": "Undertyper",
  "parent_fields": "Föräldrafält",
  "field_type": "Fälttyp",
  "sum_type": "Summatyp",
  "top_level_type": "Topnivåtyp",
  "title_type": "Rubriktyp",
  "ref_separator": "Ref.avgränsare",
  "searchable_in_reservation": "Sökbar i bokningslistor",
  "reservation_in_text_field": "Bokning i textfält",
  "mandatory": "Obligatorisk",
  "unique": "Unik",
  "multiple": "Flera",
  "editable": "Redigerbar",
  "searchable": "Sökbar",
  "listable": "Listbar",
  "primary": "Primär",
  "sortable": "Sorterbar",
  "virtual_category": "Virtuell kategori",
  "abstract_category": "Abstrakt kategori",
  "default_value": "Standardvärde",
  "category": "Kategori",
  "add_category": "Lägg till kategori",
  "exceeded_maximum_limit_categories": "Du har överstigit maxgränsen på {0} kategorier.",
  "delete_type": "Ta bort typ",
  "filter": "Filter",
  "categories": "Kategorier",
  "reference_fields": "Referensfält",
  "member_level": "Medlemsnivå",
  "help_type": "Hjälptyp",
  "source_field": "Sökfält",
  "match_field": "Matchande fält",
  "unvalid_combination_fields": "Ogiltig kombination av fält",
  "additional configuration": "Ytterligare inställningar",
  "match_mode": "Matchningsläge",
  "matchAll": "Matcha alla",
  "matchOne": "Matcha en",
  "constitutes_obstacle": "Utgör förhinder",
  "occupied_by_default": "Upptagen som standard",
  "own_object": "Eget objekt",
  "user_objects": "Användarobjekt",
  "standard": "Standard",
  "time": "Tid",
  "hours": "timmar",
  "h_mm": "h:mm",
  "standard_step": "Standardsteg",
  "minimum_step": "Minimumsteg",
  "begin_step": "Börja tidssteg på",
  "import_step": "Importsteg",
  "minimum_length": "Minimilängd",
  "maximum_length": "Maxlängd",
  "default_length": "Standardlängd",
  "minutes": "minuter",
  "begin_offset": "Startförskjutning",
  "time_slots": "Tidsspann",
  "weekday_selection": "Val av veckodag",
  "add_weekday_selection": "Lägg till veckodagsval",
  "delete_weekday_selection": "Ta bort veckodagsval",
  "date": "Datum",
  "relative_start_time": "Relativ starttid",
  "relative_end_time": "Relativ sluttid",
  "use_start_time_to_open_next_day": "Använd starttid för att öppna nästa dag",
  "use_separate_cancellation_rules": "Använd separata avbokningsregler",
  "reservation_periods": "Bokningsperioder",
  "reservation_period": "Bokningsperiod",
  "reservation_length": "Bokningslängd",
  "reservation_count": "Bokningsantal",
  "use_modified_by_when_calculating": "Använd 'redigerad av' när användarkvot beräknas",
  "time_slot": "Tidsspann",
  "sure_to_delete_time_slot": "Är du säker på att du vill ta bort det här tidsspannet?",
  "copy": "Kopiera",
  "ex_1_time_slots": "Ex.1:  8:00-17:15, 8:30-17, 9 - 17:15 (tre slots)",
  "ex_2_time_slots": "Ex.2: 08:00-08:45x0:15-17:15 (repetera slot 08:00-08:45 var 15:de minut fram till 17:15)",
  "property": "Egenskap",
  "add_time_slot": "Lägg till tidsslot(er)",
  "sure_to_delete_object": "Är du säker på att du vill ta bort det här objektet",
  "actions": "Åtgärder",
  "modification_history": "Ändringshistorik",
  "last_modified": "Senast ändrad",
  "color": "Färg",
  "add": "Lägg till",
  "search": "Sök",
  "signature": "Signatur",
  "telephone": "Telefon",
  "comment": "Kommentar",
  "integer": "Heltal",
  "length": "Längd",
  "checkbox": "Kryssruta",
  "reference": "Referens",
  "nonSearchableText": "Ej sökbar text",
  "nonSearchableReference": "Ej sökbar referens",
  "none": "-",
  "abstract": "Abstrakt",
  "physical": "Fysisk",
  "virtualStandard": "Virtuell standard",
  "virtualAbstract": "Virtuell abstrakt",
  "templateObject": "Mallobjekt",
  "default": "Standard",
  "auth_config_default": "Standard inloggningsmetod",
  "public": "Publik",
  "limited": "Begränsad",
  "hidden": "Dold",
  "date_time_intervals": "Datum",
  "year": "År",
  "week": "Vecka",
  "month": "Månad",
  "day": "Dag",
  "weekday": "Veckodag",
  "useOnly": "Använd endast",
  "strict": "Strikt",
  "dynamic": "Dynamisk",
  "confirmed": "Bekräftad",
  "planned": "Planerad",
  "preliminary": "Preliminär",
  "abstractDisplay": "Abstrakt visning",
  "physicalDouble": "Fysisk dubbel",
  "optionalDouble": "Valfri dubbel",
  "combination": "Kombination",
  "optional": "Valfri",
  "nonVirtualObjects": "Ej virtuella objekt",
  "virtual": "Virtuell",
  "incomplete": "Ofullständig",
  "never": "Aldrig",
  "always": "Alltid",
  "mon": "Mån",
  "tue": "Tis",
  "wed": "Ons",
  "thu": "Tor",
  "fri": "Fre",
  "sat": "Lör",
  "sun": "Sön",
  "no_weekday_selection": "Inget veckodagsval",
  "copy_weekday_selection": "Kopiera veckodagsval",
  "reservationPeriod": "Bokningsperiod",
  "short": "Kort",
  "user_access": "Användaråtkomst",
  "child_periods": "Barnperioder",
  "parent_periods": "Föräldrarperioder",
  "interval_type": "Intervalltyp",
  "start": "Start",
  "end": "Slut",
  "sure_to_delete_period": "Är du säker på att du vill ta bort den här perioden",
  "add_interval": "Lägg till intervall",
  "select_interval": "Välj intervall",
  "select_country": "Välj land",
  "select_type": "Välj typ",
  "from": "Från",
  "to": "Till",
  "list_holidays": "Lista högtider",
  "create_holiday_reservations_from_selection": "Skapa högtidsbokningar från urval",
  "perform_maintenance": "Utför underhåll",
  "reset_database": "Återställ databas",
  "WARNING": "VARNING",
  "this_action_is_not_recommended": "Den här åtgärden är inte rekommenderad",
  "database_is_reseted": "Databasen är återställd",
  "sure_to_reset_database": "Alla reservationer, avbokningar, reservationshistorik, reservationsutkast, reservationsregistreringar, orders och användarsessioner kommer att raderas. Är du säker på att du vill återställa den här databasen",
  "there_is_no_way_to_recall_it": "Det finns inget sätt att återkalla återställningen på",
  "successfully_performed_maintenance": "Framgångsrikt utfört underhåll",
  "maintenance_performed_for": "Underhåll utfört för",
  "maintenance_not_performed": "Underhåll inte utfört",
  "please_select_items_before_clicking_on": "Vänligen välj objekt innan du klickar på",
  "miscellaneous": "Diverse",
  "select_action": "Välj åtgärd",
  "value": "Värde",
  "close_unused_sessions": "Stäng oanvända sessioner",
  "general_description": "Generell beskrivning",
  "support_info": "Supportinformation",
  "general_name": "Generellt namn",
  "general_email": "Generell e-post",
  "general_phone": "Generell telefon",
  "general_URL_title": "Generell URL titel",
  "general_manual_title": "Generell manuell titel",
  "technical_description": "Teknisk beskrivning",
  "technical_name": "Tekniskt namn",
  "technical_email": "Teknisk e-post",
  "technical_phone": "Teknisk telefon",
  "technical_URL_title": "Teknisk URL titel",
  "technical_manual_title": "Teknisk manuell titel",
  "email_settings": "E-postinställningar",
  "email_max_members": "E-post max medlemmar",
  "do_not_use_the_user_email_address_as": "Använd inte användarens e-post adress som",
  "set": "Sätt",
  "as": "som",
  "include_empty_reservation_fields_when_sending_email": "Inkludera tomma bokningsfält när e-post skickas",
  "send_server_emails_to_Slack_for_debugging": "Skicka server-e-post till Slack för felsökning",
  "preview_of_email_template": "Förhandsvisning av e-postmall",
  "email_templates": "E-postmallar",
  "subject": "Ämne",
  "message": "Meddelande",
  "preview": "Förhandsvisning",
  "variables_to_use_in_email": "Variabler (att använda i e-post)",
  "active_features": "Aktiva funktioner",
  "customer_name": "Kundnamn",
  "calendar_background_text": "Kalenderbakgrundstext",
  "order_accept_span": "Accepteras beställningsspann",
  "allow_Java_client": "Tillåt Javaklienten",
  "allow_double_booking_of_type_without_sufficient_permissions": "Tillåt dubbelbokning av typ utan tillräckliga behörigheter",
  "max_reservation_objects": "Max bokningsobjekt",
  "max_import_field_values": "Max importerade fältvärden",
  "optional_relations": "Frivilliga relationer",
  "make_optional_if_any_object_is_optional_on_multi_selection": "Gör frivillig om något objekt är frivilligt i flerval",
  "reservation_exceptions": "Bokningsundantag",
  "hide_possibility_of_making_member_exceptions_on_reservations": "Göm möjlighet att göra medlemsundantag på bokningar",
  "reservationOrder_list": "Boknings-/orderlista",
  "use_reserve_permisson_on_objects_in_list_when_modify_permission_is_used": "Använd bokningstillstånd på objekt i listan när modifieringsbehörighet används",
  "reservation_permissions": "Bokningstillstånd",
  "allow_non_admin_users_to_change_reservation_organizations": "Tillåt icke admin-andvändare att ändra bokningsorganisation",
  "allow_user_to_change": "Tillåt användare att ändra \"påverkar ordrar\" på mallar oavsett bokningslängd",
  "selected_list": "Vald lista",
  "display_warning_when_an_object_is_unrelated": "Visa varning när ett objekt är orelaterat",
  "passwords_and_authentication": "Lösenord och autentisering",
  "password_rules": "Lösenordsregler",
  "do_not_allow_passwords_containing_login_name": "Tillåt inte lösenord att innehålla inloggningsnamn",
  "do_not_allow_passwords_on_black_list": "Tillåt inte lösenord på svarta listan",
  "require_lower_case_character": "Kräv gemen",
  "require_upper_case_character": "Kräv stor bokstav",
  "require_digit_character": "Kräv siffra",
  "require_special_character": "Kräv speciell karaktär",
  "external_web_login_URL": "Extern webinloggnings-URL",
  "user_object_patterns": "Användarobjektmönster",
  "user_settings": "Användarinställningar",
  "add_patterns": "Lägg till mönster",
  "remove_patterns": "Ta bort mönster",
  "please_select_time_zones": "Vänligen välj tidszon",
  "move_reservations_from": "Flytta bokningar från",
  "move_reservations_between_time_zones": "Flytta bokningar mellan tidszoner",
  "from_time_zone": "Från tidszon",
  "to_time_zone": "Till tidszon",
  "moving_reservations_from_time_zone": "Flyttar bokningar från tidszon",
  "external_permissions": "Externa behörigheter",
  "set_by": "Satt av",
  "short_name": "Kort namn",
  "long_name": "Långt namn",
  "time_zone": "Tidszon",
  "daylight_savings_time": "Sommartid",
  "offset": "Offset",
  "sure_to_delete_time_zone": "Är du säker på att du vill ta bort den här tidszonen",
  "add_new_time_zone": "Lägg till ny tidszon",
  "set_the_user_email_address_as": "Sätt användar-e-postadressen som",
  "reply_to": "svara till",
  "email_preferences": "E-post preferenser",
  "on_template_regardless_of_reservation_count": "på mall oavsett bokningslängd",
  "information": "Information",
  "personal_information": "Personlig information",
  "created": "Skapad",
  "expand_row": "Expandera rad",
  "collapse_row": "Fäll ihop rad",
  "created_by": "Skapad av",
  "relations": "Relationer",
  "relations_subtitle": "Manage relation types",
  "availability_related": "Tillgänglighetsrelaterade",
  "optional_related": "Frivilligrelaterade",
  "edit": "Redigera",
  "set_daterange_on_member_relation": "Sätt datumintervall på medlemsrelation",
  "cancel": "Avbryt",
  "sure_to_delete_type": "Är du säker på att du vill ta bort den här typen?",
  "delete": "Ta bort",
  "select_member_type": "Välj medlemstyp",
  "set_daterange_on_relation_object": "Sätt datumintervall på relationsobjekt",
  "select_relation_type": "Välj relationstyp",
  "delete_all": "Ta bort alla",
  "not_active": "Ej aktiv",
  "de_activate": "Inaktivera",
  "activate": "Aktivera",
  "add_member_object": "Lägg till medlemsobjekt",
  "save_added_member_object": "Spara tillagda medlemsobjekt",
  "remove_member_object": "Ta bort medlemsobjekt",
  "save_removed_member_object": "Spara borttagna medlemsobjekt",
  "add_relation_object": "Lägg till objekt",
  "save_added_relation_object": "Spara tillagda relationsobjekt",
  "remove_relation_object": "Ta bort relationsobjekt",
  "save_removed_relation_object": "Spara borttagna relationsobjekt",
  "add_organization": "Lägg till organisation(er)",
  "save_added_organization": "Spara tillagda organisation(er)",
  "remove_organization": "Ta bort organisation(er)",
  "save_removed_organization": "Spara borttagna organisation(er)",
  "add_availability_relation_object": "Lägg till tillgänglighetsrelationsobjekt",
  "save_added_availability_relation_object": "Spara tillagda tillgänglighetsrelationsobjekt",
  "remove_availability_relation_object": "Ta bort tillgänglighetsrelationsobjekt",
  "save_removed_availability_relation_object": "Spara borttagna tillgänglighetsrelationsobjekt",
  "add_optional_relation_object": "Lägg till frivilligrelationsobjekt",
  "save_added_optional_relation_object": "Spara tillagda frivilligrelationsobjekt",
  "remove_optional_relation_object": "Ta bort frivilligrelationsobjekt",
  "save_removed_optional_relation_object": "Spara borttagna frivilligrelationsobjekt",
  "columns": "Kolumner",
  "ok": "Ok",
  "select_all_fields": "Välj alla fält",
  "de_select_all_fields": "Avmarkera alla fält",
  "field_values_not_possible_to_display_or_edit_if_the_selected_objects_have_different_types": "Fältvärden är inte möjliga att se eller redigera om de valda objekten har olika typer",
  "extid_reservation_mode_already_exists": "Det finns redan ett bokningsläge med det här ext.id't. Det här bokningsläget är inte sparat.",
  "extid_availability_type_already_exists": "Det finns redan en tillgänglighetstyp med det här ext.id't. Den här tillgänglighetstypen är inte sparad.",
  "name_field_relation_already_exists": "Det finns redan en fältrelation med det här namnet. Den här fältrelationen är inte sparad.",
  "extid_field_already_exists": "Det finns redan ett fält med det här ext.id't. Det här fältet är inte sparat.",
  "extid_type_already_exists": "Det finns redan en typ med det här ext.id't. Den här typen är inte sparad.",
  "extid_object_already_exists": "Det finns redan ett objekt med det här ext.id't. Det här objektet är inte sparat.",
  "users": "Användare",
  "organization_groups": "Organisationsgrupper",
  "integration": "Integration",
  "products": "Produkter",
  "access_tokens": "Åtkomsttokens",
  "backups": "Säkerhetskopior",
  "culling": "Gallring",
  "reports": "Rapporter",
  "settings": "Inställningar",
  "views": "Vyer",
  "header_periods": "Rubrikperioder",
  "creator_user": "Skaparanvändare",
  "template_user": "Mallanvändare",
  "related_objects": "Relaterade objekt",
  "organization": "Organisation",
  "parent_organization": "Förälderorganisation",
  "roles": "Roller",
  "type_password_again": "Skriv in lösenord igen",
  "change_password": "Ändra lösenord",
  "first_name": "Förnamn",
  "last_name": "Efternamn",
  "owner": "Ägare",
  "lock_user_for_external_authentication": "Lås användare för extern autentisering",
  "allow_login": "Tillåt inloggning",
  "super": "Super",
  "admin": "Admin",
  "vue_admin": "Vyadmin",
  "client": "Klient",
  "user_object": "Användarobjekt",
  "object_permissions": "Objektbehörigheter",
  "clear": "Rensa",
  "update": "Uppdatera",
  "reinit_services": "Återinitera tjänster",
  "server_type": "Servertyp",
  "date_format": "Datumformat",
  "permissions": "Behörigheter",
  "operator": "Operator",
  "country": "Land",
  "form.validation_error.email_pattern": "${label} behöver vara en giltig e-postadress",
  "form.validation_error.guid_pattern": "${label} behöver vara ett giltigt GUID",
  "form.validation_error.required": "${label} är obligatoriskt",
  "help_ext_id": "Externt id",
  "help_show_in_culling": "Hjälptext saknas",
  "help_show_in_client": "Hjälptext saknas",
  "help_sort_res_template_types": "Hjälptext saknas",
  "help_type_res_template_types": "Typ som förekommer på bokningsmallen",
  "help_action_res_template_types": "Hjälptext saknas",
  "help_minmax_res_template_types": "Objektantal (exakt antal eller min/max)",
  "help_reservation_kind_res_template_types": "Hjälptext saknas",
  "help_ma_com_opt_res_template_types": "Obligatorisk: Obligatorisk typ för alla bokningar av nuvarande bokningsmall, kan exkluderas på en ofullständig bokning.\nKombination: Del av några kombinationer som anges nedan.\nFrivillig: Frivillig för alla bokningar av nuvarande bokningsmall, typen är alltid möjlig att välja.",
  "help_obj_virt_inco_res_template_types": "Objekt: Icke-virtuella objekt. Ett icke-virtuellt objekt måste väljas av typen.\nVirtuell: Alla objekt inklusive virtuella.\nOfullständig: Tillåt ofullständig. Tillåt en platshållare av typen.",
  "help_member_type_res_template_types": "Om och hur man använder medlemmar",
  "help_availability_type_res_template_types": "Om och hur man använder tillgänglighet",
  "help_request_type_res_template_types": "Typ av förfrågan. Den typ som ska begäras istället för att bokas direkt, till exempel 'rum",
  "help_can_per_res_template_types": "Tillåt användare att avboka bokningar utan bokningstillstånd på den här typen",
  "help_opt_rel_res_template_types": "Frivillig relation, kontrollera den fysiska typen som kommer att vara abstrakt. \nKan användas med frivilliga kurser, den fysiska gruppen kommer att vara abstrakt (kolla gruppen)",
  "help_auto_o_res_template_types": "Automatisk objektval, till exempel välj ett tillgängligt objekt (till exempel 'rum') som matchar ditt sökkriterium",
  "help_res_text_res_template_types": "Ställ in bokningstextläget (blåa bokningar)",
  "help_obst_text_res_template_types": "Ställ in läget för hindertext (gula bokningar)",
  "help_language_select": "Hjälptext saknas",
  "help_language_alt_name": "Hjälptext saknas",
  "help_language_alt_description": "Hjälptext saknas",
  "help_filter_fields": "Ett filter för att sätta vilka värden som kan anges på ett textfält",
  "help_length_fields": "Maxlängden på textfält",
  "help_min_max_fields": "Minimum- och maxvärden för heltalsfält",
  "help_sum_type_fields": "Fältet räknar automatiskt antal medlemmar för den valda typen",
  "help_top_level_type_fields": "Det här fältet kommer att visas som en kategori på den här typen och subtyper",
  "help_title_type_fields": "Den här typen används för referens när fältet visas på rottypen",
  "help_ref_separator_fields": "Separator används vid sammankoppling av värden på ett referensfält",
  "help_mandatory_fields": "Hjälptext saknas",
  "help_unique_fields": "Hjälptext saknas",
  "help_multiple_fields": "Hjälptext saknas",
  "help_editable_fields": "Hjälptext saknas",
  "help_searchable_fields": "Hjälptext saknas",
  "help_listable_fields": "Hjälptext saknas",
  "help_primary_fields": "Hjälptext saknas",
  "help_sortable_fields": "Hjälptext saknas",
  "help_type_member_types": "Typ som ska användas för att definiera medlemmen, till exempel: medlemsrelationerna ska skapas med objekt av den här typen",
  "help_member_level_member_types": "Bestämmer medlemsnivån för typen. Den största gruppen är nivå 1, subgrupper är nivå 2, etc.",
  "help_type_relation_type": "Typ som ska användas för att definiera relationen, till exempel: relationerna ska skapas med objekt av den här typen",
  "help_help_type_relation_types": "En hjälptyp används endast när ett objekt är relaterat till en huvudtyp",
  "help_source_field_field_relations": "Hjälptext saknas",
  "help_match_field_field_relations": "Hjälptext saknas",
  "help_match_mode_field_relations": "Hjälptext saknas",
  "help_operator_field_relations": "Hjälptext saknas",
  "help_constitutes_obstacle_availability_types": "Anger om tillgängligheten inte kan överbokas",
  "help_occupied_by_default_availability_types": "Anger om objekt som saknar tillgänglighetsrelationer bör vara ockuperade",
  "help_type_availability_types": "Typ som ska användas för att definiera tillgängligheten, till exempel: tillgänglighetsrelationerna ska skapas med objekt av den här typen",
  "help_own_object_availability_types": "Tillgänglighet för egen typ. Typen definierar sin egna tillgänglighet",
  "help_user_objects_availability_types": "Tillgänglighet för användarobjekt. Objekten är relaterade till användaren istället för de valda objekten",
  "help_email_max_member_system_prefs": "Ange maximalt antal medlemmer att skicka e-post till",
  "help_do_not_use_the_user_email_address_as_system_prefs": "Använd en generisk e-postaddress som \"från\"",
  "help_set_the_user_email_address_as_system_prefs": "Ange om användarens e-postadress ska användas som \"svara på\" -adress",
  "help_include_empty_reservation_fields_when_sending_email_system_prefs": "Lägg till kryssruta för tomma bokningsfält när du skickar bokning via e-post",
  "help_send_server_emails_to_Slack_for_debugging_system_prefs": "Skickar förfrågan, avvisade och accepterade e-post till Slack #applikationsnotiser",
  "help_active_features_system_prefs": "Hjälptext saknas",
  "help_customer_name_system_prefs": "Hjälptext saknas",
  "help_order_accept_span_system_prefs": "Det intervall som är acceptabelt för att göra en beställning uppfylld. Kan vara mellan 1 och 200 procent.",
  "help_allow_java_client_system_prefs": "Tillåter användare att använda Javaklientens kalender. Vissa användare kan uteslutas från detta.",
  "help_allow_double_booking_of_type_system_prefs": "Välj en typ för vilken dubbelbokning utan tillstånd att ändra på andra bokningar är möjlig",
  "help_max_reservation_objects_system_prefs": "Det maximala totala antalet objekt som kan reserveras på en bokning",
  "help_max_import_field_values": "Ange det maximala antalet fältvärden som kan importeras till ett objekt",
  "help_make_optional_if_any_object_is_optional_on_multi_selection_system_prefs": "Hjälptext saknas",
  "help_hide_possibility_of_making_member_exceptions_on_reservations_system_prefs": "Hjälptext saknas",
  "help_use_reserve_permisson_on_objects_in_list_when_modify_permission_is_used_system_prefs": "Hjälptext saknas",
  "help_allow_non_admin_users_to_change_reservation_organizations_system_prefs": "Hjälptext saknas",
  "help_allow_user_to_change_system_prefs": "Hjälptext saknas",
  "help_display_warning_when_an_object_is_unrelated_system_prefs": "Visa varning när ett icke-relaterat objekt är valt i den kalendervalda listan",
  "help_user_object_patterns_system_prefs": "Mönster för att matcha objekt från användare i personuppgiftsrapport",
  "help_external_web_login_url_system_prefs": "Hjälptext saknas",
  "help_move_reservation_system_prefs": "Flytta bokningar",
  "help_external_permissions_system_prefs": "De externa behörigheter som kan ställas in på en användare",
  "weekNumber": "Veckonummer",
  "days": "Dagar",
  "extId": "Ext.id",
  "fieldOrder": "Fältordning",
  "modified": "Ändrad",
  "modified_by": "Ändrad av",
  "created_date": "Skapad (datum)",
  "modified_date": "Ändrad (datum)",
  "activate_deactivate": "Aktivera / Avaktivera",
  "monday": "Måndag",
  "tuesday": "Tisdag",
  "wednesday": "Onsdag",
  "thursday": "Torsdag",
  "friday": "Fredag",
  "saturday": "Lördag",
  "sunday": "Söndag",
  "january": "Januari",
  "february": "Februari",
  "march": "Mars",
  "april": "April",
  "may": "Maj",
  "june": "Juni",
  "july": "Juli",
  "august": "Augusti",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "December",
  "show_all": "Visa all",
  "filter_on_field_type": "Filtrera på fälttyp",
  "integer_field": "Heltalsfält",
  "text_field": "Textfält",
  "category_field": "Kategorifält",
  "checkbox_field": "Kryssrutafält",
  "allowed_relations": "Tillåtna relationer",
  "add_new_interval": "Lägg till nytt intervall",
  "not_possible_to_add_an_interval_including_everything": "Det går inte att spara ett intervall som innehåller all, det är inte en period!",
  "listed_objects": "Listade objekt",
  "add_object": "Lägg till objekt",
  "show_all_actions": "Visa alla möjliga åtgärder",
  "show_no_actions": "Visa inga möjliga åtgärder",
  "system_information": "Systeminformation",
  "show_all_system_information": "Visa all systeminformation",
  "show_no_system_information": "Visa ingen systeminformation",
  "select": "Välj",
  "client_id": "Klient ID",
  "repeat_password": "Upprepa lösenord",
  "use_token": "Använd token",
  "last_used": "Senast använd",
  "repeated_password_should_match_with_password": "Upprepat lösenord ska matcha med lösenord",
  "api_authentication_tokens": "API autentiseringstokens",
  "accepted": "Accepterad",
  "reserved": "Reserverad",
  "cancelled": "Avbokad",
  "requested": "Begärd",
  "rejected": "Nekad",
  "low": "Låg",
  "high": "Hög",
  "normal": "Normal",
  "extreme": "Extrem",
  "wild_thing": "Vilt",
  "you_kidding": "Du måste skämta med mig",
  "cancel requested": "Avboka begäran",
  "help_short_interval": "Sätter ett extra kort interval; 1 timme, istället för 5 timmar",
  "inactive": "Inaktiv",
  "all": "Alla",
  "reservation": "Bokning",
  "infoReservation": "Infobokning",
  "reservationModeOrder": "Bokningsläge ordning",
  "filter_on_root_periods": "Filtrera på rotperioder",
  "root_periods": "Rotperioder",
  "all_periods": "All perioder",
  "show_hidden_periods": "Visa dolda perioder",
  "hide_hidden_periods": "Göm dolda perioder",
  "hidden_periods": "Dolda perioder",
  "filter_on_template_type": "Filtrera på typ av bokningsmall",
  "sort_on": "Sortera på",
  "filter_on_active": "Filterera på aktiv",
  "second_column": "Andra kolumnen",
  "action_will_delete_information": "Den här åtgärden kommer att radera alla bokningar, avbokningar, bokningshistorik, bokningsutkast, reservationsregistreringar, orders och användarsessioner.",
  "really_sure_to_reset_database": "Är du HELT säker på att du vill återställa databasen",
  "execute_reset_database": "Utför 'Återställ databas'",
  "help_auth_config_active": "Aktivera inloggningsmetod",
  "help_auth_config_default": "Ange som en standard inloggningsmetod",
  "log_level": "Loggnivå",
  "help_log_level": "Hjälptext saknas",
  "DEBUG": "FELSÖK",
  "SIGN": "SIGNERA",
  "REQUIRED": "OBLIGATORISK",
  "help_enabled_applications": "Aktiverade applikationer för denna autentiseringskonfiguration",
  "enabled_applications": "Aktiverade applikationer",
  "strategy": "Strategi",
  "help_auth_configs_strategy": "Strategi för autentisering",
  "summary": "Sammanfattning",
  "help_auth_configs_summary": "Hjälptext saknas",
  "use_MFA": "Använda MFA",
  "help_use_mfa": "Använd Multifaktorautentisering",
  "timeedit_entity_id_missing": "TimeEdit enhets-id saknas",
  "help_calendar_background_text": "Hjälptext saknas",
  "idp_metadata_url": "IdP Metadata URL",
  "help_idp_metadata_url": "Metadata URL ",
  "idp_entity_id": "Idp enhets-id",
  "help_idp_entity_id": "Enhets-id till identitetsleverantören. \nAdressen till identitetsleverantörens metadata. Om lämnat blankt, antas det vara samma om \"IdP MetaData URL\".",
  "timeedit_entity_id": "TimeEdit enhets-id",
  "help_timeedit_entity_id": "Entitets-id för den här TimeEdit-autentiseringsservern. \nEnhets-id för TimeEdit-tjänsten. Det här id't bör vara unikt eftersom det kan förekomma i samma \"IdP Metadata URL\" som ett annat \"TimeEdit enhets-id\".\nId:t ska bara innehålla [a-zA-Z0-9_-.:/]. Detta kan till exempel vara på formuläret \"timeedit.net/customer_signature\". Om mer än en konfiguration används kan den använda formuläret \"timeedit.net/customer_signature/user_type\". \nOBLIGATORISK",
  "idp_logout_url": "IdP utloggnings-URL",
  "help_idp_logout_url": "Identitetsleverantörens utloggnings-endpoint (dess SAML Single Logout Service). TimeEdit behöver den för att slutföra SAML-utloggning i båda riktningarna: den skickar sin utloggningsförfrågan hit när TimeEdit initierar utloggning, och sitt svar hit när din identitetsleverantör initierar utloggning. Rekommenderat: fyll alltid i den via autofyll från IdP-metadata när din IdP har en sådan; du kan även ange den manuellt för att ersätta värdet.",
  "idp_entry_point_url": "IdP ingångsport-URL",
  "help_idp_entry_point_url": "Hjälptext saknas",
  "idp_public_key": "IdP Privat nyckel",
  "help_idp_public_key": "Hjälptext saknas",
  "signature_signing": "Signatursignering",
  "help_signature_signing": "Använd signaturer. Signera meddelanden och verifiera signaturer.\nDet här alternativet aktiverar signering av SSO-förfrågningar. Som standard använder den inbäddad signering av XML.\nFör att kräva signering av svar, använd nedan alternativet \"Kräv signaturer\".\nDet kan också kompletteras med \"Använd dynamiska signaturer\" i vilket fall signering kan utföras på ett annat sätt.\nAll signering bör inte stängas av annat än för teständamål.\nSom standard är detta alternativ aktiverat. Använd dynamiska signaturer.\nSignera och verifiera meddelanden dynamiskt beroende på meddelandemetod.\nOm du aktiverar den här kryssrutan blir signeringsmetoden beroende av meddelandebindningen. Om meddelandebindningen är en HTTP-omdirigering (GET) använder den URL-signering. Om meddelandebindningen är en HTTP-POST använder den signering inbäddad i XML. Detta är en fördel om omdirigeringarna behöver ha en begränsad storlek eftersom det kommer att göra omdirigeringsadressen kortare eller använda POST-bindning om meddelanden är större.\nOm du aktiverar det här alternativet kan det ändra hur meddelanden signeras.\nSom standard är det här alternativet inte aktiverat.\n",
  "signature_algorithm": "Signaturalgoritm",
  "help_signature_algorithm": "Algoritm för att signera meddelanden, både XML och URL. Välj den algoritm som ska användas när du signerar förfrågningar.\nStandard är nu \"SHA-256\" och är vanligtvis att föredra i nyare konfigurationer och är ett säkrare alternativ.\nDenna algoritm styr alla typer av signering om signering är aktiverad.",
  "always_use_post_binding": "Använd alltid POST-bindning",
  "help_always_use_post_binding": "Föredrar http POST-metoden framför \"Redirect\" för SSO-förfrågningar.\nDen här kryssrutan gör att förfrågningar och svar föredrar HTTP-POST-bindning framför HTTP-omdirigeringsbindning när detta stöds. Detta kan användas om webbadresser är stora och IdP inte accepterar stora webbadresser.\nSom standard är detta alternativ inte aktiverat.",
  "label_prefer_http_post": "Saml Binding",
  "prefer_http_post": "Föredra HTTP POST",
  "help_prefer_http_post": "Denna inställning gör att SAML-autentiseringen använder HTTP-POST istället för HTTP-Redirect. Detta kan användas om IdP inte accepterar stora URL:er.\nSom standard är denna inställning inaktiverad (vilket innebär att HTTP-Redirect används). Det är inte rekommenderat att använda denna inställning utan att verifiera att IdPn stöder HTTP-POST.",
  "label_slo_enabled": "Utloggning hos identitetsleverantören",
  "slo_enabled": "Avsluta identitetsleverantörens session vid utloggning",
  "help_slo_enabled": "När en användare loggar ut från TimeEdit ber TimeEdit även identitetsleverantören att avsluta sin session — vilket kan logga ut användaren från andra appar som delar samma inloggning. Kräver en utloggnings-URL för IdP. Av som standard; TimeEdits utloggning över flera flikar påverkas inte.",
  "error_slo_missing_logout_url": "Utloggning hos identitetsleverantören är på men ingen utloggnings-URL för IdP är angiven, så den körs inte. Ange en utloggnings-URL (från metadata eller manuellt) eller stäng av detta.",
  "attributes_parsing": "Attributanalys",
  "user_name_attribute": "Användarnamnsattribut",
  "help_user_name_attribute": "Namn på användarnamnsattribut. Attributnamnet i SAML-svaret som motsvarar användarens användarnamn.\nExempel: \"eduPersonPrincipalName\"\nDet är möjligt att bara extrahera en del av attributvärdet som användarnamn genom att ange attributnamnet följt av ett likhetstecken och sedan mönstret för värdet, där ? markerar det faktiska användarnamnet.\nExempel: \"mail=?@timeedit.se\"",
  "email_attribute": "Epostattribut",
  "help_email_attribute": "Namn på epostattribut.\nAttributnamnet i SAML-svaret som motsvarar användarens e-postadress.",
  "given_name_attribute": "Förnamnsattribut",
  "help_given_name_attribute": "Namn på attributet för användarens förnamn. Attributnamnet i SAML-svaret som motsvarar användarens förnamn.",
  "last_name_attribute": "Efternamnsattribut",
  "help_last_name_attribute": "Namn på användarens efternamnsattribut. Attributnamnet i SAML-svaret som motsvarar användarens efternamn.",
  "mandatory_attributes": "Obligatoriska attribut",
  "help_mandatory_attributes": "Värden som måste ställas in för de givna attributen.\nEn lista över attribut som är obligatoriska för alla användare.",
  "forbidden_attributes": "Förbjudna attribut",
  "help_forbidden_attributes": "Lista över attribut med värden som en användare INTE får ha för att logga in.\nEn lista med attribut som är förbjudna för alla användare.",
  "user_object_matching": "Matchning av användarobjekt",
  "help_user_object_matching": "Hjälptext saknas",
  "OBJECT_EXTID": "Objekt ext.id",
  "OBJECT_FIELD": "Objekt fält",
  "user_object_extid": "SAML2 mönster för matchning av användarobjekt",
  "help_user_object_extid": "Mönster som kan addera strängar till attributvärdet innan det jämförs med ett fält. Till exemple om fältet som ska matchas har innehållet \"student_123\" men attributet innehåller \"123\" ska mönstret vara på formen \"student_?\". Där ? senare byts ut mot värdet när användaren loggar in.",
  "user_object_field": "TimeEdit fält för användarobjekt",
  "help_user_object_field": "Välj vilket fält som ska användas vid matching av attributvärdet. ExtId används om inget annat är satt. Alla fält kan användas men ska helst vara \"unika\" och \"sökbara\".",
  "user_object_attribute": "SAML2 attribut för användarobjekt",
  "help_user_object_attribute": "Välj vilket SAML2 attribut som ska användas för att matcha användarobjektet. Detta attribut måste finnas i SAML2 svaret.",
  "mandatory_user_object": "Obligatoriska användarobjekt",
  "help_mandatory_user_object": "Ange om användarobjekt ska vara obligatoriskt eller inte.\nOm ja OCH användarobjektsfältet inte är tomt, kommer användaren endast att tillåtas in i systemet om ett användarobjekt hittas.\nOm nej ställs ett användarobjekt in om det hittas, men i båda fallen får användaren logga in.",
  "set_permissions": "Ange behörigheter",
  "help_set_permissions": "Ställ in när autentiseringspluginen ska ställa in användarbehörigheter.\nAlltid: Ange alltid behörigheter baserat på den här konfigurationen.\nNya användare: Ange behörigheter baserat på denna konfiguration eller användare första gången de loggar in.\nAldrig: Ställ aldrig in några behörigheter vid autentisering. ",
  "ALWAYS": "ALLTID",
  "NEW_USERS": "NYA ANVÄNDARE",
  "NEVER": "ALDRIG",
  "affiliations": "Anknytning",
  "affiliations_count": "{0} anknytningar",
  "manage_affiliations": "Hantera anknytningar",
  "manage_affiliations_tooltip": "Spara autentiseringskonfigurationen innan du hanterar anknytningar",
  "help_affiliations": "Konfigurera användarens anknytning genom att tilldela noder och roller, användarobjekt och standardorganisation baserat på SAML-attributen. För varje anknytning lägg till ett eller flera attributnyckelvärdespar för matchning (skiftlägesokänsligt). Konfigurera sedan vilka noder och roller, användarobjekt och standardorganisation som användaren ska få. Användarobjekt och standardorganisation är valfritt.",
  "require_full_attribute_matches": "Kräv fullständig attributmatchning",
  "help_require_full_attribute_matches": "Aktiverat kräver denna inställning att varje matching måste vara fullständig match (dvs hela ordet är samma, skiftlägesokänsligt). Inaktiverat tillåts partiell matching, t.ex. kan ett attributvärde \"stud\" matcha med \"student\".",
  "affiliation_matching": "Anknytningsmatchning",
  "allow_single_affiliation_match": "Tillåt enkel anknytning",
  "allow_multiple_affiliation_matches": "Tillåt multipla anknytningar",
  "help_allow_multiple_affiliation_matches": "Aktiverat gör denna inställning att en användare får noder med roller och användarobjekt från samtliga matchade anknytningsrader. Standardorganisation sätts då från första matchningen som innehåller standardorganisation.  Inaktiverat gör att en användare får noder med roller, användarobjekt och standardorganisation från första matchningen och inga fler (oavsett om rader har användarobjekt eller standardorganisation). Ordningen är uppifrån och ned.",
  "attributes": "Attribut",
  "values": "Värden",
  "add_row": "Lägg till rad",
  "add_permission": "Add permission",
  "attributes_pattern": "Attributmönster",
  "help_attributes_pattern": "Attribut tillståndsmönster. Om attributen utvärderas till sant kommer motsvarande behörigheter att läggas till.\nMönstret har samma form som \"obligatoriska attribut\". Ett tomt värde kommer alltid att utvärderas till \"sant\".",
  "organization_role": "Organisation / roll",
  "help_organization_role": "Användarorganisationer och roller.\nAnvändarens organisationer och roller. Angett i formatet:\n\"org1=roll1\", \"org2=roll2\" ... \"orgN=rollN\"\nEn organisation kan anges som en sökväg åtskild av \";\"",
  "help_auth_configs_standard_organization": "Användarstandardorganisation. Standardorganisation för användaren.\nEn organisation kan ges som en sökväg åtskild av \";\"",
  "help_auth_configs_user_objects": "Ytterligare användarobjekt.\nEn lista över externa objekt-ID'n separerade med en ny rad.\nExempel: \"dep_sales\" \n\"dep_support\"\n\"course_abc123\"\n\"course_cde345\"",
  "editable_features": "Redigerbara funktioner",
  "move": "Flytta",
  "are_you_sure_to_move": "Är du säker på att du vill flytta",
  "reservations_from": "bokning(ar) från",
  "preserving_local_time": "med bevarad lokal tid",
  "number_of_reservations_moved": "Antal reservationer flyttade",
  "number_of_cancellations_moved": "Antal avbokningar flyttade",
  "number_of_history_reservations_moved": "Antal reservationer från historik flyttade",
  "number_of_culls_moved": "Antal gallringar flyttade",
  "help_text_restemplates_timerule": "",
  "help_text_restemplates_privaterole": "",
  "help_text_restemplates_standardorg": "",
  "help_text_restemplates_active": "",
  "help_text_restemplates_affectorders": "",
  "help_text_restemplates_deafultstatus": "",
  "help_text_delete_reservations_when_culling": "",
  "help_text_restemplates_movereservations_count": "",
  "help_text_types_personaldata": "",
  "help_text_types_aliastype": "",
  "help_text_types_external_ownership": "",
  "help_text_periods_user_access": "",
  "sub_organizations": "Suborganisationer",
  "sure_to_delete_org": "Är du säker på att du vill ta bort den här organisationen",
  "delete_organization": "Ta bort organisation",
  "url": "URL",
  "YES": "Ja",
  "NO": "Nej",
  "STANDARD": "Standard",
  "HIDDEN": "Dold",
  "READ_ONLY": "Skrivskydd",
  "visibility": "Synlighet",
  "last_login": "Senaste inloggning",
  "active_user": "Aktiv användare",
  "require_password_on_first_sign_in": "Kräv lösenord vid första inloggning",
  "user_will_be_required_to_set_new_password_on_first_log_in": "Användaren måste ange ett nytt lösenord vid första inloggningen",
  "app_permission": "Appbehörighet",
  "app_permissions": "Appbehörigheter",
  "scopes": "",
  "scopes_to_choose_from": "",
  "role": "Roll",
  "organizations_and_roles": "Organisationer och roller",
  "set_app_permissions": "Sätt appbehörigheter",
  "authentication_configuration": "Autentiseringskonfiguration",
  "authentication_configurations": "Autentiseringskonfigurationer",
  "readOnly": "Skrivskyddad",
  "add_language": "Lägg till språk",
  "padding": "Padding",
  "contact_email": "Kontakt E-mail",
  "help_api_key_storage": "Kopiera och lagra denna nyckel säkert. Den kan inte ses igen.",
  "help_api_key_regenerate": "Klicka på Generate Key igen för att återskapa nyckeln.",
  "help_api_key_properties": "Det går att ändra egenskaper för en skapad nyckel.",
  "integration.calendar.configuration.delete_confirmation": "Är du säker på att du vill ta bort denna konfiguration?",
  "integration.calendar.configuration.title": "Inställningar",
  "integration.calendar.configuration.subtitle": "Konfigurera inställningar nödvändiga för att integrera mot Microsoft 365",
  "integration.calendar.configuration.alert.title": "Var försiktig",
  "integration.calendar.configuration.alert.description": "Korrekta värden är nödvändiga för att integrera mot Microsoft 365.",
  "integration.calendar.configuration.form.title": "Konfigurera integrationsinställningar för att kommuniceara med Microsoft 365",
  "integration.calendar.configuration.form.client_id.description": "Applikationens klient-ID för att autentisera kommunikation med Microsoft 365.",
  "integration.calendar.configuration.form.client_id.label": "Klient-ID",
  "integration.calendar.configuration.form.client_secret.description": "Applikationens klienthemlighet för att autentisera kommunikation med Microsoft 365. Uppdatera befintlig klienthemlighet, men hemligheten kommer inte exponeras när konfigurationerna visas.",
  "integration.calendar.configuration.form.client_secret.label": "Klienthemlighet",
  "integration.calendar.configuration.form.name.description": "Namn för autentiseringsklienten.",
  "integration.calendar.configuration.form.name.label": "Namn",
  "integration.calendar.configuration.form.tenant_id.description": "Kund-ID för autentiseringsklienten för integrationen mot Microsoft 365.",
  "integration.calendar.configuration.form.tenant_id.label": "Kund-ID",
  "integration.calendar.logs.title": "Loggar",
  "integration.calendar.logs.subtitle": "Se loggar och spåra historisk integrationsstatus",
  "integration.calendar.logs.error": "Misslyckades med att hämta loggar",
  "integration.calendar.audit.title": "Ändringshistorik",
  "integration.calendar.audit.user": "Användare",
  "integration.calendar.audit.action.CREATED": "Skapad",
  "integration.calendar.audit.action.UPDATED": "Uppdaterad",
  "integration.calendar.audit.action.DELETED": "Borttagen",
  "integration.calendar.audit.error": "Misslyckades med att hämta ändringshistorik",
  "integration.calendar.mapping.title": "Mappning",
  "integration.calendar.mapping.subtitle": "Konfigurera hur data mappas mellan TimeEdit och Microsoft 365",
  "integration.calendar.sync_settings.title": "Synkning",
  "integration.calendar.sync_settings.subtitle": "Ställ in synkronisering mellan TimeEdit och Microsoft 365",
  "integration.calendar.sync_settings.actions.save_changes": "Save",
  "integration.calendar.sync_settings.actions.discard_changes": "Discard changes",
  "integration.calendar.sync_settings.category_color.save_successful": "Category color saved successfully.",
  "integration.calendar.sync_settings.category_color.label": "Category color",
  "integration.calendar.sync_settings.category_color.tooltip": "Select a color for the Microsoft Outlook category, which will be applied to events synced from TimeEdit.",
  "integration.calendar.sync_settings.actions.confirm_delete": "Är du säker på att du vill ta bort den här synkningen?",
  "integration.calendar.sync_settings.form.objects.title": "Objects to sync",
  "integration.calendar.sync_settings.form.name.description": "Namn på synkinställningen.",
  "integration.calendar.sync_settings.form.name.label": "Name",
  "integration.calendar.sync_settings.form.reservation_mode.description": "Only sync reservations of the selected modes",
  "integration.calendar.sync_settings.form.reservation_mode.label": "Reservation mode",
  "integration.calendar.sync_settings.form.reservation_mode.placeholder": "Select reservation modes",
  "integration.calendar.sync_settings.form.reservation_status.description": "Only sync reservations of the selected statuses",
  "integration.calendar.sync_settings.form.reservation_status.label": "Reservation status",
  "integration.calendar.sync_settings.form.reservation_status.placeholder": "Select reservation statuses",
  "integration.calendar.sync_settings.form.subject_field_id.description": "Field to be used as the title of the calendar event",
  "integration.calendar.sync_settings.form.subject_field_id.label": "Subject field",
  "integration.calendar.sync_settings.form.description_field_ids.description": "Field to be included in the descripiton of the calendar event",
  "integration.calendar.sync_settings.form.description_field_ids.label": "Description fields",
  "integration.calendar.sync_settings.form.subject_field.add_btn.label": "Add alternative",
  "integration.calendar.sync_settings.form.subject_field.remove_btn.label": "Remove selected alternatives",
  "integration.calendar.sync_settings.form.description_field.add_btn.label": "Add row",
  "integration.calendar.sync_settings.form.description_field.remove_btn.label": "Remove selected rows",
  "integration.calendar.sync_settings.form.location_field.add_btn.label": "Add alternative",
  "integration.calendar.sync_settings.form.location_field.remove_btn.label": "Remove selected alternatives",
  "integration.calendar.sync_settings.form.sync_mode.description": "Direction to sync the objects",
  "integration.calendar.sync_settings.form.sync_mode.label": "Sync mode",
  "integration.calendar.sync_settings.form.sync_period.description": "Välj om synkroniseringen ska ske med ett absolut eller relativt tidsintervall.",
  "integration.calendar.sync_settings.form.sync_period.label": "Time interval type",
  "integration.calendar.sync_settings.form.sync_period.static.start_date.description": "Start of the period to sync",
  "integration.calendar.sync_settings.form.sync_period.static.start_date.label": "Start date",
  "integration.calendar.sync_settings.form.sync_period.static.end_date.description": "End of the period to sync",
  "integration.calendar.sync_settings.form.sync_period.static.end_date.label": "End date",
  "integration.calendar.sync_settings.form.sync_mode.te_in.label": "Microsoft 365 → TimeEdit",
  "integration.calendar.sync_settings.form.sync_mode.te_out.label": "TimeEdit → Microsoft 365",
  "integration.calendar.sync_settings.form.sync_mode.te_out.template_column.value": "Value",
  "integration.calendar.sync_settings.form.sync_mode.te_out.free_text.blank_space": "MELLANSLAG",
  "integration.calendar.sync_settings.form.sync_mode.te_two_way.label": "Tvåvägssynkronisering",
  "integration.calendar.sync_settings.form.sync_period.static.label": "Absolut intervall",
  "integration.calendar.sync_settings.form.sync_period.relative.label": "Relativt intervall",
  "integration.calendar.sync_settings.form.sync_period.date_range.label": "Datumintervall",
  "integration.calendar.sync_settings.form.sync_period.interval.label": "Intervall (dagar)",
  "integration.calendar.sync_settings.form.sync_period.interval.tooltip": "Antal dagar i framtiden att synkronisera. Gräns: 1 - 365 dagar.",
  "integration.calendar.sync_settings.form.sync_target.description": "Bestämmer vilka objekt som ska synkroniseras",
  "integration.calendar.sync_settings.form.sync_target.label": "Synkroniseringsmål",
  "integration.calendar.sync_settings.form.sync_target.option.all": "Alla",
  "integration.calendar.sync_settings.form.sync_target.option.selected": "Valda",
  "integration.calendar.sync_settings.form.sync_target.option.filtered": "Filtrerade",
  "integration.calendar.sync_settings.form.sync_type.description": "Typ av objekt att synkronisera.",
  "integration.calendar.sync_settings.form.sync_type.label": "Typ",
  "integration.calendar.user_status.title": "Användarstatus",
  "integration.calendar.user_status.subtitle": "Se status per användare",
  "integration_settings_danger_zone": "Danger zone",
  "integration_settings_danger_zone_description": "Editing properties here can break your connection with the TimeEdit server. Proceed with caution",
  "integration_settings_header": "Configure the integration settings for communicating with TE Server",
  "integration_settings_base_url": "Base URL",
  "integration_settings_base_url_description": "The URL that should be used to connect to the TimeEdit server",
  "integration_settings_base_url_required": "Base URL is required",
  "integration_settings_username": "Username",
  "integration_settings_username_description": "The username that should be used to authenticate with the TimeEdit server",
  "integration_settings_username_required": "Username is required",
  "integration_settings_password": "Password",
  "integration_settings_password_description": "The password that should be used to authenticate with the TimeEdit server",
  "integration_settings_password_required": "Password is required",
  "integration_settings_certificate": "Certificate key",
  "integration_settings_certificate_description": "The certificate key that should be used to authenticate with the TimeEdit server",
  "integration_settings_certificate_required": "Certificate key is required",
  "system_general_setting_title": "General Settings",
  "system_general_setting_subtitle": "General settings for organization",
  "system_reservation_template_title": "Reservation Templates",
  "system_reservation_template_subtitle": "Manage templates",
  "system_padding_rule_title": "Padding Rules",
  "system_padding_rule_subtitle": "Manage padding rules",
  "system_padding_viewer_title": "Padding Viewer",
  "system_padding_viewer_subtitle": "View rules",
  "system_field_relation_title": "Field Relations",
  "system_field_relation_subtitle": "Manage field relations",
  "application_integration_setting_title": "Integrations Settings",
  "application_integration_setting_subtitle": "Manage integration settings",
  "report_settings": "Report Settings",
  "manage_data_source_types": "Manage Data Source Types",
  "manage_mapping": "Manage Mapping",
  "application_exam_setting_title": "Exam Settings",
  "application_exam_type_mapping_subtitle": "Object Types",
  "application_exam_in_core_subtitle": "TE Exam in TE Core",
  "application_exam_reservation_setting_subtitle": "Reservation Settings",
  "application_exam_object_relationship_subtitle": "Object Relationship",
  "fields_confirmation_delete": "Are you sure you want to delete this field?",
  "padding_rule_confirmation_delete": "Are you sure you want to delete this padding rule?",
  "reservation_mode_confirmation_delete": "Are you sure you want to delete this reservation mode?",
  "reservation_template_confirmation_delete": "Are you sure to delete this reservation template?",
  "user_confirmation_delete": "Are you sure you want to delete this user?",
  "object_type_confirmation_delete": "Are you sure you want to delete this object type?",
  "dynamic_availability_confirmation_delete": "Are you sure you want to delete this dynamic availability?",
  "field_relation_confirmation_delete": "Are you sure you want to delete this field relation?",
  "new_field_relation": "New field relation",
  "clear_cache": "Töm cache",
  "clear_cache_confirm_message": "Du är på väg att tömma all cache för Preferences i denna organisation. Fortsätt?",
  "clear_cache_success_message": "Cachen har tömts",
  "new_relation_type": "New relation type",
  "relation_type_confirmation_delete": "Are you sure you want to delete this relation type?",
  "USE_ONLY": "Use only",
  "STRICT": "Strict",
  "DYNAMIC": "Dynamic",
  "memberships": "Memberships",
  "memberships_subtitle": "Manage memberships",
  "membership_confirmation_delete": "Are you sure you want to delete this membership?",
  "new_membership": "New membership",
  "ABSTRACT": "Abstract",
  "PHYSICAL": "Physical",
  "availability_relations": "Tillgänglighetsrelationer",
  "availability_relations_title": "Availability relations",
  "availability_relations_subtitle": "Manage availability relations",
  "availability_relation_confirmation_delete": "Are you sure you want to delete this availability relation?",
  "new_availability_relation": "New availability relation",
  "INTEGER": "Integer",
  "TEXT": "Text",
  "CATEGORY": "Category",
  "CHECKBOX": "Checkbox",
  "SIGNATURE": "Signature",
  "EMAIL": "Email",
  "URL": "URL",
  "TELEPHONE": "Telephone",
  "COMMENT": "Comment",
  "LENGTH": "Length",
  "REFERENCE": "Reference",
  "NON_SEARCHABLE_TEXT": "Non searchable text",
  "NON_SEARCHABLE_REFERENCE": "Non searchable reference",
  "SHOW_ALL": "Show all",
  "org_visibility_public": "Kund produktion",
  "org_visibility_hidden": "Kund annan (test/acceptance etc)",
  "org_visibility_private": "Intern (visas med \"internal:\" sök prefix)",
  "time_rules": "Tidsregler",
  "time_rules_subtitle": "Manage time rules",
  "time_rule_confirmation_delete": "Are you sure you want to delete this time rule?",
  "new_time_rule": "New time rule",
  "support_info_subtitle": "The support info is visible in Core under Help > Support",
  "time_rule_active_criteria": "Active Criteria",
  "advanced_preferences_title": "Advanced",
  "advanced_preferences_subtitle": "Advances system preferences",
  "holiday_reservations_title": "Semesterbokningar",
  "holiday_reservations_subtitle": "Manage holiday reservations",
  "time_zones": "Tidszoner",
  "time_zones_subtitle": "Manage time zones",
  "time_zone_confirmation_delete": "Are you sure you want to delete this time zone?",
  "data_sources": "Data Sources",
  "data_sources_subtitle": "Manage data sources",
  "new_data_sources": "New data sources",
  "report_template_confirmation_delete": "Are you sure you want to delete this report template?",
  "data_sources_confirmation_delete": "Are you sure you want to delete this data sources?",
  "help_metadata_url": "Genom att lägga till länk till kundens idp metadata kan du importera efterföljande information från metadata.\nKnappen kommer endast att fylla i värdena, du måste fortfarande trycka på spara-knappen.",
  "autofill_from_metadata": "Fyll i från metadata",
  "help_autofill_from_metadata": "Efter att ha fyllt i \"IdP Metadata URL\" och \"IdP Entity Id\" kan den här knappen användas för att autofylla resterande fält från metadata. Kom ihåg att spara, knappen kommer endast fylla i inmatningsfälten. Kryssrutan för \"Föredra HTTP POST\" kan markeras innan autofyllning, den avmarkeras automatiskt om ingen POST binding hittas i metadata av autofyllningen.",
  "object_confirmation_delete": "Are you sure you want to delete this object?",
  "exam_v3_object_type_settings_title": "Object type settings",
  "exam_v3_object_type_settings_sub_title": "Object type",
  "exam_v3_reservation_settings_title": "Reservation settings",
  "exam_v3_reservation_settings_sub_title": "Reservation",
  "seat_management_settings_title": "Seat Allocation Settings",
  "seat_management_allocation_mode_sub_title": "Seat Allocation",
  "LOAD": "Load",
  "UTILIZATION": "Utilization",
  "DEMAND_ANALYTIC": "Demand Analytic",
  "HEATMAP": "Heatmap",
  "ui.action.add": "Add",
  "ui.action.delete": "Delete",
  "ui.action.remove": "Remove",
  "ui.table.edit_columns": "Ändra kolumner",
  "object_manager.object_table.update.button": "Uppdatera",
  "object_manager.object_table.update.description": "En batchoperation har slutförts. Ladda om tabellen för att se de senaste uppgifterna.",
  "object_manager.object_table.column.ext_id": "Ext ID",
  "object_manager.object_table.column.types": "Type(s)",
  "object_manager.object_table.column.organizations": "Organisation(s)",
  "object_manager.object_table.column.active": "Active",
  "object_manager.object_table.data.active": "Active",
  "object_manager.object_table.data.inactive": "Inactive",
  "object_manager.object_table.data.yes": "Yes",
  "object_manager.object_table.data.no": "No",
  "object_manager.object_table.context_menu.open": "Open",
  "object_manager.object_table.context_menu.compare": "Compare",
  "object_manager.object_table.context_menu.duplicate": "Duplicate",
  "object_manager.object_table.context_menu.delete": "Delete",
  "object_manager.object_table.actions.create_new": "Create new",
  "object_manager.object_table.actions.edit": "Edit",
  "object_manager.object_table.actions.duplicate": "Duplicate",
  "object_manager.object_table.actions.delete": "Delete",
  "object_manager.object_table.actions.export": "Export",
  "object_manager.object_table.footer.selected_items": "{0} selected",
  "object_manager.object_table.drawer.associations.title": "Associations",
  "object_manager.object_table.drawer.associations.context_menu.remove": "Remove",
  "object_manager.object_table.drawer.associations.actions.add": "Add",
  "object_manager.object_table.drawer.associations.actions.add.tooltip.disabled": "Associations of this type cannot be added to the object.",
  "object_manager.object_table.drawer.associations.actions.remove": "Remove",
  "object_manager.object_table.drawer.associations.memberships.title": "Memberships",
  "object_manager.object_table.drawer.associations.relations.title": "Relations",
  "object_manager.object_table.drawer.associations.availability_related.title": "Availability related",
  "object_manager.object_table.drawer.associations.optional_related.title": "Optional related",
  "object_manager.bulk-edit-modal.success-message": "Uppdatering av objekt har startat, klicka på Batchoperationer för att se status",
  "object_manager.select_objects_modal.title": "Add objects",
  "object_manager.adjust_filters_modal.title": "Adjust filter",
  "object_manager.bulk-edit-dropdown.general.label": "Allmän info",
  "object_manager.bulk-edit-dropdown.fields.label": "Fält",
  "object_manager.bulk-edit-dropdown.associations.label": "Relationer och medlemskap",
  "object_manager.bulk-edit-dropdown.organizations.label": "Organisationer",
  "object_manager.bulk-edit-modal.title": "Redigera objekt",
  "object_manager.bulk-edit-modal.general.title": "Redigera allmän information",
  "object_manager.bulk-edit-modal.general.property.label": "Egenskap",
  "object_manager.bulk-edit-modal.general.personal-information.label": "Personlig data",
  "object_manager.bulk-edit-modal.general.is-active.label": "Är aktiv",
  "object_manager.bulk-edit-modal.general.types.label": "Typer",
  "object_manager.bulk-edit-modal.organizations.title": "Redigera organisationer",
  "object_manager.bulk-edit-modal.subtitle": "{0} {1} objekt valda",
  "object_manager.bulk-edit-modal.okText": "Uppdatera objekt",
  "object_manager.bulk-edit-modal.keep.label": "Behåll",
  "object_manager.bulk-edit-modal.removeAll.label": "Rensa",
  "object_manager.bulk-edit-modal.add.label": "Lägg till",
  "object_manager.bulk-edit-modal.findReplace.label": "Hitta och ersätt",
  "object_manager.bulk-edit-modal.replaceAll.label": "Ersätt alla",
  "object_manager.bulk-edit-modal.removeSpecific.label": "Ta bort specifik",
  "object_manager.bulk-edit-modal.findReplace.findPlaceholder": "Välj värde(n) att hitta",
  "object_manager.bulk-edit-modal.findReplace.replacePlaceholder": "Välj värde(n) att ersätta med",
  "object_manager.bulk-edit-modal.add.placeholder": "Välj värde(n) att lägga till",
  "object_manager.bulk-edit-modal.replaceAll.placeholder": "Välj nya värden",
  "object_manager.bulk-edit-modal.removeSpecific.placeholder": "Välj värden att ta bort",
  "object_manager.bulk-edit-modal.findReplace.find-input-label": "Hitta",
  "object_manager.bulk-edit-modal.findReplace.replace-input-label": "Ersätt med",
  "object_manager.bulk-edit-modal.add.input-placeholder": "Värde att lägga till",
  "object_manager.bulk-edit-modal.replaceAll.input-placeholder": "Nytt värde",
  "object_manager.bulk-edit-modal.removeSpecific.input-placeholder": "Värde att ta bort",
  "object_manager.bulk-edit-modal.checkAll.label": "Markera alla",
  "object_manager.bulk-edit-modal.uncheckAll.label": "Avmarkera alla",
  "object_manager.bulk-edit-modal.warning.clear": "Du kommer att rensa värdet {0} för {1} valda objekt. Detta går inte att ångra.",
  "object_manager.bulk-edit-modal.warning.replace-all": "Du kommer att ersätta alla värden för {0} för {1} objekt. Befintliga värden tas bort permanent och ersätts. Detta går inte att ångra.",
  "object_manager.bulk-edit-modal.tooltip.no-categories": "Det finns inga kategorier för det här fältet. Vänligen konfigurera kategorier i Configuration/Fields.",
  "object_manager.bulk-edit-modal.match-rule.match-all": "Alla",
  "object_manager.bulk-edit-modal.match-rule.match-any": "En",
  "object_manager.bulk-edit-modal.match-rule.label": "Match",
  "object_manager.bulk-edit-modal.match-rule.tooltip": "Matcha mot hela inmatningen",
  "object_manager.bulk-edit-modal.placeholder.search": "Sök",
  "object_manager.export-modal.checkbox-all": "Markera/avmarkera alla",
  "object_manager.export-modal.title": "Exportera {0} objekt",
  "object_manager.export-modal.ok-text": "Exportera",
  "object_manager.export-modal.object-type.tooltip": "Typen av objekt som exporteras",
  "object_manager.export-modal.id-type.label": "ID typ",
  "object_manager.export-modal.id-type.tooltip": "Det externa ID:t som används för att identifiera objektet i exporten.",
  "object_manager.export-modal.id-type.external": "Externt ID",
  "object_manager.export-modal.format.label": "Filformat",
  "object_manager.export-modal.format.tooltip": "Välj exportfilens format. Stödda format: XLSX och CSV.",
  "object_manager.export-modal.format.csv": "CSV (.csv)",
  "object_manager.export-modal.format.xlsx": "Excel (.xlsx)",
  "object_manager.export-modal.separator.label": "Separator",
  "object_manager.export-modal.separator.tooltip": "Tecken som används för att separera flera värden inom ett fält (till exempel: komma eller semikolon)",
  "object_manager.export-modal.separator.comma": "Komma (,)",
  "object_manager.export-modal.separator.semicolon": "Semikolon (;)",
  "object_manager.export-modal.separator.pipe": "Pipe (|)",
  "object_manager.export-modal.separator.forward-slash": "Snedstreck (/)",
  "object_manager.export-modal.separator.tab": "Tab",
  "object_manager.export-modal.redirect-message": "Exporteringen har startat, omdirigerar till jobbet...",
  "object_manager.export-modal.success-message": "Exporteringen har startat, klicka på Batch Operations för att se framstegen",
  "object_manager.export-modal.fields.label": "Välj fält att inkludera",
  "object_manager.export-modal.object.id": "Internt ID",
  "object_manager.export-modal.object.ext-id": "Ext. ID",
  "object_manager.export-modal.subtypes-warning": "Du har valt en objekttyp som innehåller underliggande typer. Fält och associationer som är unika för de underliggande typerna kommer inte att ingå i exporten",
  "object_manager.export-modal.same-sheet": "Samma",
  "object_manager.export-modal.separate-sheet": "Separat",
  "object_manager.export-modal.separate-sheet-type": "Kalkylbladstyp",
  "object_manager.export-modal.separate-sheets-info": "Exportera associationer i separata kalkylblad, endast tillgängligt med XLSX.",
  "object_manager.bulk-edit-modal.tooltip.field-not-editable": "Det här fältet är inte konfigurerat för att vara redigerbart. Vänligen kontrollera din fältkonfiguration.",
  "object_manager.export-modal.associations.label": "Välj associationer att inkludera",
  "object_manager.export-modal.attributes.label": "Välj allmän information att inkludera",
  "availability_collection.reservation_mapping.title": "Reservationskartläggning",
  "availability_collection.reservation_mapping.reservation_mode_select": "Tillgänglighetsläge",
  "availability_collection.reservation_mapping.reservation_template_select": "Tillgänglighetsmall",
  "availability_collection.reservation_mapping.availability_type": "Tillgänglighetstyp",
  "availability_collection.timeslot.title": "Tidslucka",
  "availability_collection.timeslot.delete": "Är du säker på att du vill ta bort den här tidsluckan?",
  "availability_collection.period.title": "Tillgänglighetsperiod",
  "availability_collection.period.delete": "Är du säker på att du vill ta bort den här tillgänglighetsperioden?",
  "object_generation": "",
  "object_generation_title": "",
  "object_generation_subtitle": "",
  "allocate_general_settings": "Generella Inställningar",
  "automatic_allocation_from_waitlist_label": "Automatisk tilldelning från väntelista",
  "automatic_allocation_from_waitlist_tooltip": "Tilldela studenter automatiskt från väntelistan när en plats blir tillgänglig.",
  "registration_section": "Registrering",
  "block_student_conflict_tooltip": "Hindra studenter från att registrera sig när det finns en schemakonflikt",
  "import_settings": "Importinställningar",
  "validate_file": "Validera fil",
  "click_or_drag_file": "Klicka eller dra filen till detta område för att ladda upp",
  "support_single_file_upload": "Stöd för uppladdning av en enda fil",
  "back": "Tillbaka",
  "next": "Nästa",
  "date_limits": "Datum period",
  "defined_date_range": "Använd datumgräns",
  "defined_date_range_help": "Hård datumgräns kommer att appliceras efter att den relativa tiden har beräknats. Start och slut är valfria och kan lämnas tomma.",
  "offset_start": "Relativ start",
  "offset_start_help": "Relativ start från nu",
  "offset_end": "Relativt slut",
  "offset_end_help": "Relativt slut från nu",
  "preview_import_file_info": "Förhandsgranskning av importfil. Kontrollera att filen ser ut som avsett. Alla objekt ingår inte i förhandsgranskningen. Vi kommer inte att titta på andra blad i din fil.",
  "alternative_title": "Alternativ titel",
  "hub_activity_info": "Om inställningarna för \"Namn\" inte gäller används \"Alternativ titel\" istället.",
  "suites.curriculum": "Curriculum",
  "suites.workload": "Workload",
  "suites.scheduling": "Scheduling",
  "suites.engagement": "Engagement",
  "suites.insights": "Insights",
  "suites.platform": "Platform"
}
